import React from "react";

export const ErrorPage = () => {
    return(
        <h1>Página não encontrada</h1>
    )
}